import { render, staticRenderFns } from "./appel.vue?vue&type=template&id=3ce4363a"
import script from "./appel.vue?vue&type=script&lang=ts"
export * from "./appel.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports